<app-header></app-header>
<main class="container mt-2">
    <router-outlet></router-outlet>
</main>
<footer class="footer">
    <div class="content has-text-centered">
        <p>
            <span i18n>If you like <strong>EveryBoard</strong>, follow us!</span>
            &nbsp;
            <a href="https://discord.gg/n4jsfsdmrZ"><fa-icon [icon]="faDiscord"></fa-icon></a>&nbsp;
            <a href="https://github.com/EveryBoard/EveryBoard"><fa-icon [icon]="faGithub"></fa-icon></a>&nbsp;
            <a href="https://facebook.com/EveryBoard"><fa-icon [icon]="faFacebook"></fa-icon></a>
        </p>
    </div>
</footer>
